export default class ThemecustomService {
  getAll() {
    return fetch("https://api.tradersr.com/api/themecustom")
      .then(res => res.json());
  }
}